import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant utilitaire à monter à l'intérieur du Router.
 * Remet le scroll en haut à chaque changement de route OU de hash significatif.
 * Si l'URL contient un hash (#section), on laisse l'ancrage natif gérer.
 */
const ScrollToTop = () => {
  const { pathname, search, hash, key } = useLocation();

  const resetScrollPosition = () => {
    const scrollingElement = document.scrollingElement || document.documentElement;
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    if (scrollingElement) {
      scrollingElement.scrollTop = 0;
      scrollingElement.scrollLeft = 0;
    }
  };

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const previous = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => {
        window.history.scrollRestoration = previous;
      };
    }
    return undefined;
  }, []);

  useLayoutEffect(() => {
    if (hash) return; // ancrage HTML natif (#xxx)

    // Double reset pour couvrir les mises à jour de layout après navigation.
    resetScrollPosition();
    requestAnimationFrame(() => {
      resetScrollPosition();
      setTimeout(resetScrollPosition, 60);
    });
  }, [pathname, search, hash, key]);

  return null;
};

export default ScrollToTop;
